import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import {
    selectAddableGroupTypes,
    selectCampaignTypesForBannerCreation,
    selectCampaignTypesForDnaBannerCreation
} from '../selectors/groupEdit/group/group';
import { AccessRights } from '../typings/common';
import { OperatorFeaturesFragment } from '../typings/graphql-grid';
import { CampaignAndGroupSelectorEntityToSelectType } from '../typings/state';

import { GroupsHelpers } from './GroupsHelpers/GroupsHelpers';

export function getAccessRightsForCampaignAndGroupSelector(
    features: OperatorFeaturesFragment,
    accessRights: AccessRights,
    type?: CampaignAndGroupSelectorEntityToSelectType,
    campaign?: SelectorItems
): { canAddInDna: boolean; canAddInDnaOnly: boolean; fullyAvailable: boolean } {
    const addableGroupTypes = selectAddableGroupTypes(features, accessRights);
    const campaignTypesForBannerCreation = selectCampaignTypesForBannerCreation(
        features,
        accessRights
    );
    const campaignTypeForDnaBannerCreation = selectCampaignTypesForDnaBannerCreation(
        features,
        accessRights
    );

    const fullyAvailableGroupTypes = GroupsHelpers.getFullyAvailableGroupTypes();
    const fullyAvailableCampaignTypesForBannerCreation = GroupsHelpers.getFullyAvailableCampaignTypesForBannerCreation();

    let canAddInDna = false;
    let fullyAvailable = false;

    switch (type) {
        case CampaignAndGroupSelectorEntityToSelectType.BANNER:
            canAddInDna = Boolean(
                campaign &&
                    [
                        ...campaignTypesForBannerCreation,
                        ...campaignTypeForDnaBannerCreation
                    ].includes(campaign.type)
            );

            fullyAvailable =
                canAddInDna &&
                Boolean(
                    campaign &&
                        fullyAvailableCampaignTypesForBannerCreation.includes(
                            campaign.type
                        )
                );

            break;
        case CampaignAndGroupSelectorEntityToSelectType.GROUP:
            canAddInDna = Boolean(
                campaign && addableGroupTypes.includes(campaign.type)
            );

            fullyAvailable =
                canAddInDna &&
                Boolean(
                    campaign && fullyAvailableGroupTypes.includes(campaign.type)
                );

            break;
        default:
            break;
    }

    return {
        canAddInDna,
        canAddInDnaOnly:
            canAddInDna && Boolean(accessRights.canEditInternalAds),
        fullyAvailable
    };
}
